import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Form } from 'react-bootstrap';
import { FiRefreshCw } from 'react-icons/fi';
import { TOGGLE_LIVE_MODE } from 'actions/chargerStatus';

const LiveModeToggle = ({ onManualRefresh, showWarning }) => {
  const dispatch = useDispatch();
  const isLiveMode = useSelector((state) => state.chargerStatus.isLiveMode);

  const handleLiveModeChange = (e) => {
    dispatch({ type: TOGGLE_LIVE_MODE, payload: e.target.checked });
  };

  return (
    <div className="live-mode-toggle-block">
      <Form.Check
        type="switch"
        id="live-mode-switch"
        label="Live"
        checked={isLiveMode}
        onChange={handleLiveModeChange}
        style={{ marginBottom: 0 }}
      />

      <FiRefreshCw
        size={18}
        onClick={() => !isLiveMode && onManualRefresh()}
        style={{
          cursor: isLiveMode ? 'not-allowed' : 'pointer',
          opacity: isLiveMode ? 0.4 : 1,
          transition: 'opacity 0.2s',
        }}
        title={isLiveMode ? 'Disabled during live updates' : 'Refresh data'}
      />

      {isLiveMode && showWarning && (
        <span style={{ fontSize: '0.75rem', color: '#e6a817', whiteSpace: 'nowrap' }}>
          ⚠ Select a status to receive alerts
        </span>
      )}
    </div>
  );
};

LiveModeToggle.propTypes = {
  onManualRefresh: PropTypes.func.isRequired,
  showWarning: PropTypes.bool,
};

export default LiveModeToggle;
